import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

const dataBoth = require('./data/dataBoth.json');
const dataSingles = require('./data/dataSingles.json');
const dataDoubles = require('./data/dataDoubles.json');

const COL_WIDTH = 50;

const sourceData = [dataBoth, dataSingles, dataDoubles];

class CharacterChart extends Component {
    constructor(props){
        super(props);
        this.state = {mX: 0, mY: 0, clicked:false, xClick:0, xOff: 0};
        
        this.createCharacterChart = this.createCharacterChart.bind(this);
    }

    componentDidMount() {
        this.createCharacterChart();
    }

    componentDidUpdate() {
        this.createCharacterChart();
    }

    createCharacterChart() {

    }

    onMouseDown(e) {
        let x = e.clientX;
        e.preventDefault();
        
        this.setState(prevState => ({
            xClick: x + this.state.xOff,
            clicked: true
        }));
    }

    onMouseUp(e) {
        this.setState(prevState => ({
            clicked: false
        }));
    }

    onMouseMove(e) {
        if (this.state.clicked) {
            let maxX = COL_WIDTH*dataBoth.length - 1920;
            let xOff = Math.min(maxX, Math.max(0, this.state.xClick - e.clientX));
            console.log(dataBoth.length);
            this.setState({ mX: e.clientX, mY: e.clientY, xOff:xOff });
        }
    }    

    render() {
        let source = sourceData[this.props.dataSource];
        
        let xOff = this.state.xOff;
        let height = 300;
        let maxHeight = Math.max.apply(Math, dataBoth.map(function(obj){return obj.y;}));
        let maxBarHeight = height - COL_WIDTH - 30;
        
        source.sort(function(a, b) {
            return b.y - a.y;
        });

        let chart = source.map(function(value, i) {
            let h = value["y"]/maxHeight * maxBarHeight;
            let x = i*COL_WIDTH-xOff;
            let result = [];
            
            result.push(<rect width={COL_WIDTH} height={Math.max(1, h)} x={x} y={Math.max(height - h - COL_WIDTH, 1)} />);
            result.push(<image href={getCharFilename(value["x"], 0, "gray")} width={COL_WIDTH} height={COL_WIDTH} x={x} y={height-COL_WIDTH} />);
            result.push(<text x={x + COL_WIDTH/2} y={height - h - COL_WIDTH - 10} textAnchor={"middle"}>{value["y"]}</text>);
            return result;
        });
        
        return (
            <svg className="CharacterChart" width={1920} height={height} onMouseDown={this.onMouseDown.bind(this)} onMouseMove={this.onMouseMove.bind(this)} onMouseUp={this.onMouseUp.bind(this)}>
              { chart }
            </svg>
        );
    }
}

export default CharacterChart;
